module.exports = __webpack_public_path__ + "static/media/cityportal.c7655bd4.svg";